import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import InstarVisionCard from 'components/Software/macOS/InstarVision/Layout/instarVisionCard01';
import NavButtons from 'components/Software/macOS/InstarVision/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "InstarVision v3 für macOS",
  "path": "/Software/macOS/InstarVision/Layout/",
  "dateChanged": "2018-01-25",
  "author": "Mike Polinowski",
  "excerpt": "Richten Sie Ihren Video-Canvas-Bereich mit einem Klick im Layout-Menü ein. Wählen Sie ein Layout, das Ihren Anforderungen und der Anzahl aktiver Kameras entspricht. Das Layout wird immer auf den Standardwert zurückgesetzt, wenn Sie die Software neu starten. Der Startstandard kann im Systemmenü eingestellt werden.",
  "image": "../P_SearchThumb_InstarVision_Windows.png",
  "social": "/images/Search/P_SearchThumb_InstarVision_Windows.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-Windows-InstarVision_white.webp",
  "chapter": "Software"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='InstarVision v3 für macOS' dateChanged='2018-01-25' author='Mike Polinowski' tag='INSTAR IP Camera' description='Das InstarVision Surveillance Center ist eine IP-Kamera-Software, die 64 Kameras gleichzeitig unterstützen kann, einschließlich Netzwerkkameras, USB-Kameras mit Fernzugriff und Sekundärinstallationen der Software.' image='/images/Search/P_SearchThumb_InstarVision_Windows.png' twitter='/images/Search/P_SearchThumb_InstarVision_Windows.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Software/macOS/InstarVision/Layout/' locationFR='/fr/Software/macOS/InstarVision/Layout/' crumbLabel="Layout" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/c0c204a90fd622e6654da2e6532314f8/29114/Banner_en-InstarVision2-0_Layout.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "16.521739130434785%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAeElEQVQI143HMQ6CQBSE4XcVOZ+FHUR6ChaqNVZ0ehUaW00g4QLQsuBmWcxvlFDYGCb5MjPC7MAasD24EZ798vFsjdaa6BiDt4h6jGQftf+h6glVub/SypE3L+IkIzzsSe8GkaJFig65GORqll73JgPBqWR3vn3/G+CmwPV440scAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/c0c204a90fd622e6654da2e6532314f8/e4706/Banner_en-InstarVision2-0_Layout.avif 230w", "/de/static/c0c204a90fd622e6654da2e6532314f8/d1af7/Banner_en-InstarVision2-0_Layout.avif 460w", "/de/static/c0c204a90fd622e6654da2e6532314f8/7f308/Banner_en-InstarVision2-0_Layout.avif 920w", "/de/static/c0c204a90fd622e6654da2e6532314f8/e1c99/Banner_en-InstarVision2-0_Layout.avif 1380w", "/de/static/c0c204a90fd622e6654da2e6532314f8/76ea5/Banner_en-InstarVision2-0_Layout.avif 1840w", "/de/static/c0c204a90fd622e6654da2e6532314f8/f696c/Banner_en-InstarVision2-0_Layout.avif 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/c0c204a90fd622e6654da2e6532314f8/a0b58/Banner_en-InstarVision2-0_Layout.webp 230w", "/de/static/c0c204a90fd622e6654da2e6532314f8/bc10c/Banner_en-InstarVision2-0_Layout.webp 460w", "/de/static/c0c204a90fd622e6654da2e6532314f8/966d8/Banner_en-InstarVision2-0_Layout.webp 920w", "/de/static/c0c204a90fd622e6654da2e6532314f8/445df/Banner_en-InstarVision2-0_Layout.webp 1380w", "/de/static/c0c204a90fd622e6654da2e6532314f8/78de1/Banner_en-InstarVision2-0_Layout.webp 1840w", "/de/static/c0c204a90fd622e6654da2e6532314f8/882b9/Banner_en-InstarVision2-0_Layout.webp 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/c0c204a90fd622e6654da2e6532314f8/81c8e/Banner_en-InstarVision2-0_Layout.png 230w", "/de/static/c0c204a90fd622e6654da2e6532314f8/08a84/Banner_en-InstarVision2-0_Layout.png 460w", "/de/static/c0c204a90fd622e6654da2e6532314f8/c0255/Banner_en-InstarVision2-0_Layout.png 920w", "/de/static/c0c204a90fd622e6654da2e6532314f8/b1001/Banner_en-InstarVision2-0_Layout.png 1380w", "/de/static/c0c204a90fd622e6654da2e6532314f8/161ec/Banner_en-InstarVision2-0_Layout.png 1840w", "/de/static/c0c204a90fd622e6654da2e6532314f8/29114/Banner_en-InstarVision2-0_Layout.png 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/c0c204a90fd622e6654da2e6532314f8/c0255/Banner_en-InstarVision2-0_Layout.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "layout",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#layout",
        "aria-label": "layout permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Layout`}</h2>
    <p>{`Passen Sie die Anordnung des Video Canvas an. Wählen Sie eine geeignete Anordnung der Kamerakanäle auf dem Video Canvas im Layout Menü. Die Anordnung wird bei jedem Neustart der Software wieder auf den Start-Up Modus zurückfallen. Dieses Standard Layout können Sie im `}<a parentName="p" {...{
        "href": "/de/Software/macOS/InstarVision/System/"
      }}>{`System Menü`}</a>{` festlegen.`}</p>
    <InstarVisionCard mdxType="InstarVisionCard" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Die Position der Videokanäle kann per Drag & Drop angepasst werden. Greifen (Linke Maustaste) Sie einfach den Videokanal und ziehen Sie ihn an die gewünschte Position. Die beiden Kanäle werden daraufhin ihre Position tauschen.`}</p>
    <p><img parentName="p" {...{
        "src": "/de/40df2adf620f6ba17a1716467ab59527/Layout_Viewport_Grid.gif",
        "alt": "Adjust the Layout of your Video Canvas"
      }}></img></p>
    <p>{`Bewegen Sie Ihren Mauszeiger über den Rand der Software und ziehen Sie die Oberfläche auf die Größe, die Sie für Ihre Ansprüche benötigen. Sie können die Seiten Navigation, über den dünnen Button auf halber Höhe, auch schließen und somit die verfügbare Fläche für den Video Canvas maximieren. Ein Rechtsklick auf den Video Canvas schalten diesen in einen Vollbildmodus, bei dem die Benutzeroberfläche ausgeblendet wird. Ein Druck auf die Esc bringt Sie wieder zurück zur normalen Ansicht.`}</p>
    <h3 {...{
      "id": "passen-sie-die-anordnung-des-video-canvas-an",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#passen-sie-die-anordnung-des-video-canvas-an",
        "aria-label": "passen sie die anordnung des video canvas an permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Passen Sie die Anordnung des Video Canvas an`}</h3>
    <h4 {...{
      "id": "1-x-1-layout",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#1-x-1-layout",
        "aria-label": "1 x 1 layout permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`1 x 1 Layout`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/8a8227bf0aa47e57c283378189df97e2/2bef9/InstarVision2_Layout_1x1.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.086956521739125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC+ElEQVQoz42SW0+bBQCGv7/gxcJULEK0rl0P9OuZ9is9ch60HMZHoZTaIqwMaleYAxY3FMcwE3HTbBfGaJZNb+bdZmJiMsdBl+gW17JJ+SiGXXixO2JcFpTHhP0B3+S9fZL3ySv8eK/I93fz/HBvndWCwnJe4e5DhXxRYa2o8PuGQnFzE6VUolQqsf3HFspGkZ9WV1hdWWb5zh3u//oLt27e5NsbNxC+W/mZ9SfP2AX2+H/5F9j9B54+2+Wvv5/y+M8nPCisUSjkETq6jciJVt67MM+p2VkWPv+Ky1e/4ZMvrnPu0pcMn5qnZ/T0fuX0JPLIOKncOGPTJ0jlRogkBmiMHuX20hKPt7cRGpqNeEJlODwvUy2qkJqMuBodWPx2tLUejAEvxqAXc70Xo09CL9VgDbpwN3nQON3o3W7MPi9Lqyvs7OwguCQNDreKWErP25kA05NBho9ZSSVtDKU99A/5CMt+OqK1tLUHqW8OEAjbsddZkepqaGhxodJouf8gv69D6B2oRmcoQwqVE2hQ0xsT6YoeJvamgcRbJjp79LR0m2mKeIn2y4S7G2nvbkVONhDu86CzGdBaJAprj54Dj8Zt2GpUmOwH8dS/SmunFslfiRzTER3UUNdVib/rJTwRM6EjbejNekS7BcnvxOB4g654iORIgs2tEuztIZycayQ5bqEnIRLpOUx62kI8ayIcUxOMVOBtryAkV+IMH6Ss6gAvHCjjRVU5qtfKqTr0Cq6gCV+LyNqj3/ZvImTnfBy/YGbqioOJiyayCybeuWQhtyiSOS8yOmPj2BkLA1Na2garaO57HTnlpE02EBnQEem10pGwsbH18PnkVM5BfFJDckZD/F01fROHGJzRkvlYR2bBwMg5I0NnTQx/YGR0UU3msyrSCxVkFtXkPjIzddHFxLzE7eVbFNcVhOzJeqJJETlu54hcTaRfpC/toH/MyvEzLnLv+5CHrXQmzaRPS+TmfaRnLWTPO8nN1TJ21s2JWYlPr3zI9Wtf8x8kjQr3W5VC/gAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/8a8227bf0aa47e57c283378189df97e2/e4706/InstarVision2_Layout_1x1.avif 230w", "/de/static/8a8227bf0aa47e57c283378189df97e2/d1af7/InstarVision2_Layout_1x1.avif 460w", "/de/static/8a8227bf0aa47e57c283378189df97e2/7f308/InstarVision2_Layout_1x1.avif 920w", "/de/static/8a8227bf0aa47e57c283378189df97e2/e3723/InstarVision2_Layout_1x1.avif 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/8a8227bf0aa47e57c283378189df97e2/a0b58/InstarVision2_Layout_1x1.webp 230w", "/de/static/8a8227bf0aa47e57c283378189df97e2/bc10c/InstarVision2_Layout_1x1.webp 460w", "/de/static/8a8227bf0aa47e57c283378189df97e2/966d8/InstarVision2_Layout_1x1.webp 920w", "/de/static/8a8227bf0aa47e57c283378189df97e2/a9a89/InstarVision2_Layout_1x1.webp 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/8a8227bf0aa47e57c283378189df97e2/81c8e/InstarVision2_Layout_1x1.png 230w", "/de/static/8a8227bf0aa47e57c283378189df97e2/08a84/InstarVision2_Layout_1x1.png 460w", "/de/static/8a8227bf0aa47e57c283378189df97e2/c0255/InstarVision2_Layout_1x1.png 920w", "/de/static/8a8227bf0aa47e57c283378189df97e2/2bef9/InstarVision2_Layout_1x1.png 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/8a8227bf0aa47e57c283378189df97e2/c0255/InstarVision2_Layout_1x1.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h4 {...{
      "id": "2-x-2-layout",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#2-x-2-layout",
        "aria-label": "2 x 2 layout permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`2 x 2 Layout`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/2e2cafe709e1706469cb381616163fbe/2bef9/InstarVision2_Layout_2x2.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.086956521739125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAADGElEQVQozyXQaU/bBQCA8X4KY0xMhukyWSEI0myx60GhtPSkB9CDf9djlqbXCrSyUSrgGNcanTijL0xc5kxAp+wFWyKgHGaYIWV4IGCri90mc4kJLmqiDh+jPsnvCzyi6dkFlm/tkP+myOZOkfWNr1jNf8Hq2jrLny4zNz/HG1dXGJ1aYnzyY4Yvf8TY5WuMv3ud3HsLnL+yzFvX1nl/eoarH36AyCkoCSWcpPs7iZ1O44rEsfoD2PxeHEEBja2ZtoCVtqCJBls9cqMStVmN2qxAaVTgCNjwJ/3MfbLA9tYWIo22HEXdEzhanqbFeQhjayU6iwqNUYXKIEUql+IQ6vFE1PhiBvR2JQanAtvxY3Sdfh73CRO2dhk3VpYolUqIQl1qTK5yhEg1rlAFZt9BZAYJkqpnqDlaid6qwhs0IPg1OAJS+ofTDAylCIdtZAajJKIeolE3+fzn7O39gqgjU4u39wDe3jKC/U8hpA5ijT+ONfYYrfEDtMfKGRvuIRENEAw7GO5P0RUTONt3inOjI6RTSbK9Pez+eJd/E70yMUD2TJK+s52Mv5b6z9hEiomLXYxdiDB6Ps6pwSHcsZO4I2FSvVkGX8ry5oWXuXTpbdIvZgh1pyjdvcf+/iNEa5vbbP1wh+07u3z5/S75wk+s7jxgceMesze/ZulmnpkbRWZWSyxuPmCj9Cv3f4ffgO/2YPH2H8wXHnL/54c8+utPRM0+A40uBXpvE9p2A00+OxqfD3tHD22hJB0dLvpGc0wv5Vnbus38Z7eYnF3h3MUrmPxxGj1BtJ4Qm9sF+HsfkVEwU2eXYxa0eELNhE86yWQi5Eb6GXihE0ezkaBVx6uZNKY2N5VHjiGWVPCkWIy4ogJJrZRy6RG2vi38/7CrWyDd7eNMpoNYzEI4pCOdqKPdW81A1ojNosarU2KR11D3XC0mXT3VNYc4XFXGUVkVDfUyVA3PMnN9hmKhiOid13PkhiJEo2oUejFag4RkQonOU0aTvQqdUYa9VY/JYkA4bkc4Ycbtb8TqUeDyGrG11CNvPMx4boSpySn+AQ+5GHVd8+zlAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/2e2cafe709e1706469cb381616163fbe/e4706/InstarVision2_Layout_2x2.avif 230w", "/de/static/2e2cafe709e1706469cb381616163fbe/d1af7/InstarVision2_Layout_2x2.avif 460w", "/de/static/2e2cafe709e1706469cb381616163fbe/7f308/InstarVision2_Layout_2x2.avif 920w", "/de/static/2e2cafe709e1706469cb381616163fbe/e3723/InstarVision2_Layout_2x2.avif 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/2e2cafe709e1706469cb381616163fbe/a0b58/InstarVision2_Layout_2x2.webp 230w", "/de/static/2e2cafe709e1706469cb381616163fbe/bc10c/InstarVision2_Layout_2x2.webp 460w", "/de/static/2e2cafe709e1706469cb381616163fbe/966d8/InstarVision2_Layout_2x2.webp 920w", "/de/static/2e2cafe709e1706469cb381616163fbe/a9a89/InstarVision2_Layout_2x2.webp 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/2e2cafe709e1706469cb381616163fbe/81c8e/InstarVision2_Layout_2x2.png 230w", "/de/static/2e2cafe709e1706469cb381616163fbe/08a84/InstarVision2_Layout_2x2.png 460w", "/de/static/2e2cafe709e1706469cb381616163fbe/c0255/InstarVision2_Layout_2x2.png 920w", "/de/static/2e2cafe709e1706469cb381616163fbe/2bef9/InstarVision2_Layout_2x2.png 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/2e2cafe709e1706469cb381616163fbe/c0255/InstarVision2_Layout_2x2.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h4 {...{
      "id": "3-x-3-layout",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#3-x-3-layout",
        "aria-label": "3 x 3 layout permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`3 x 3 Layout`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/3ce60f06931ca968d73fe6290a3e03e8/2bef9/InstarVision2_Layout_3x3.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.086956521739125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAADFklEQVQozyXMaU8bBACA4X5SZ3TiwDFaehfaQjl6IoS20FEoKwPbQrcyGXQtYA+KHZOj6Q5gGgabsgRJWCCIjmWXIzOCU4KxYx6MzJnF4wuJEv8Bf+A1hucHPIKKikqEIhESiQSpRIxCLkWpkKGUyxAJ81BIJTQ6amhx1eM95qCl0YnX58cTTBJJjjCYukhkIM3i0k0erqwg+PzBQ1Y3n5HZfsHWry/IPNliI/MTGz9ssvboEbfv3WV2LM14PMRkqp8H06PMX53g7tomt1czfDS7RDg1wUbmCX/+8TuCU5219CZO8sGlJPGRcwSicbxnQniDp2kLn6bO6yF6wsdc6izXL6VZnBjlXLCd404rVTYjOr0SY0UR33y7xu4/uwicDVpstXm0tmpoPanG7dfhaqnB2VRDjduMyWpCKVWglYjRqFQo5XJkUjm5QhHZuVlkHzmEMP8I6xvr7O3tIehO2nGfKOTUe6X4Q1rcHQrebtCg0ZVQZi6i0WMnEOujsStKQ3sX/tgANc0eChRvMZoaItwZIDcvi+3tZ/xPMDhVR2JKT2LSwMB1I30fWghe0BI8r6Y7XUbsfBW9STeh9/2E4n7OpsK0+B1UVaq4MNRDW1MdCvVhnm7/sh+aLHJy819GKH+NgtIstPpsivU5mOw5GG05VNpF+HxHafPXEwkFiPQGcRytokB1mLHxi3R0dXLg9Zd4ur21H7rqj6Ev02MoN6IvLUelKuaVN6QcOCjm1YMi3swWI9fqkRWVUFhajlpXQnGZkXKDBYPJgslcQbFOx/Pnv+2HnyzMcHX+Uz5e/ILpxfsMj0Rpv7yMb+YvfNd+xjPxmMlb33Nv/Ue+XH/M/e8y3Lxzh/mFORaWPmNmdobB9Bh/7/67H/YkAgTOOOmJNRGJ+omHXEzfGKN7Yo7U3AqxqUXC/d0k+pvp63MzMOwmPezk8pCPWKKZZp8De52Jr1e/YmdnB0G8512stiKstkIs1VKqrRYMZgmakkMYTWo0unwslQVU22TYrTJstfk01KvpeMeKq0GH3izDZBFz5co4y8u3+A+L/tgPWAW95AAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/3ce60f06931ca968d73fe6290a3e03e8/e4706/InstarVision2_Layout_3x3.avif 230w", "/de/static/3ce60f06931ca968d73fe6290a3e03e8/d1af7/InstarVision2_Layout_3x3.avif 460w", "/de/static/3ce60f06931ca968d73fe6290a3e03e8/7f308/InstarVision2_Layout_3x3.avif 920w", "/de/static/3ce60f06931ca968d73fe6290a3e03e8/e3723/InstarVision2_Layout_3x3.avif 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/3ce60f06931ca968d73fe6290a3e03e8/a0b58/InstarVision2_Layout_3x3.webp 230w", "/de/static/3ce60f06931ca968d73fe6290a3e03e8/bc10c/InstarVision2_Layout_3x3.webp 460w", "/de/static/3ce60f06931ca968d73fe6290a3e03e8/966d8/InstarVision2_Layout_3x3.webp 920w", "/de/static/3ce60f06931ca968d73fe6290a3e03e8/a9a89/InstarVision2_Layout_3x3.webp 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/3ce60f06931ca968d73fe6290a3e03e8/81c8e/InstarVision2_Layout_3x3.png 230w", "/de/static/3ce60f06931ca968d73fe6290a3e03e8/08a84/InstarVision2_Layout_3x3.png 460w", "/de/static/3ce60f06931ca968d73fe6290a3e03e8/c0255/InstarVision2_Layout_3x3.png 920w", "/de/static/3ce60f06931ca968d73fe6290a3e03e8/2bef9/InstarVision2_Layout_3x3.png 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/3ce60f06931ca968d73fe6290a3e03e8/c0255/InstarVision2_Layout_3x3.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h4 {...{
      "id": "8-x-8-layout",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#8-x-8-layout",
        "aria-label": "8 x 8 layout permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`8 x 8 Layout`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/49a1b5f90ef182ffbef46d05ec7c6f29/2bef9/InstarVision2_Layout_8x8.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.086956521739125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACyklEQVQozyWO3YobZQBA8y5654WID9CVFlo3sU12k+zs5meSyWySSeY/32Qyk8xkZjbZJEVKbatVKAiiWLyxPoAXtawg3rvuUqEFL4qF4gPYPVI914fDyYWJiuYe0LUUFOMQK7CwQwMvnBBlKwaui2pptPQ2bUNBEzVUs4Hh+UTpEmvsICKTr7/5ih8ePSJ30LhEvvgerc4uSRJgjATBIkIEffJtlw/aUzragCz1yZcuUaq8z9b1LbaUhIo6REz6TLKIJyc/8/vpKblep4nSqKE0t9FMiWrrOqq+zWTWQPYj9r0VZbmK7VSplq4wUBqUpH2q/sf0ghGOKNMZFnhy8pjnz56TWzgG65HBainwUpO+t4ekvst84eLMj9l8+T0i9fHmXTapRzZQiIOE9Ivv8OIEd9Kg2nmHX379iVev/ibX0zuo8i6GpSOimHiRcfez2/S0Jt5IRdc7dI0B7nTGsK9w2C5Tkm7giyG6Xsd2ety7f4cXf70ELsh9+uAe6SaisHcD3TUZRz722KBndgmWU6ypxvF6hmUP2ZF3iG9muHObcWYzigVDq4vt65z/8RQuLsj13AIV5TKKLuNHLrLWp9geMLTfhHWMiY48/JC6dhV5UMf2dNxQ4MxMbGGg6D4fNQ/57eycN+QkKU+xeJlGLc9salBs9blq36ZhasSZjuk7FHevsbtzhQPpGmFoIndVouWMcahQsQO27VucPn0Gr/8hl4xMptYA4dYZCAlrPmW4uMsoTbG8AqXG21iH+yTCxrEkjLFM2yhQlt8imKtoUYaz+Zw/X7z8/9DoNHHbNdbrFH8RYMUR60/uMwkFyVIwXzl06hVG7RqbVYLIAry5Tbp2iBLBLA5Z3XnAj49POD87I7e8dcR0brFXK5NlCyxLQXgqutOi329wtI4JFiHzI+c/J45j1utjssWUllLGD3U0XWJ9c8nDbx/yL8lvEIA/O4aKAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/49a1b5f90ef182ffbef46d05ec7c6f29/e4706/InstarVision2_Layout_8x8.avif 230w", "/de/static/49a1b5f90ef182ffbef46d05ec7c6f29/d1af7/InstarVision2_Layout_8x8.avif 460w", "/de/static/49a1b5f90ef182ffbef46d05ec7c6f29/7f308/InstarVision2_Layout_8x8.avif 920w", "/de/static/49a1b5f90ef182ffbef46d05ec7c6f29/e3723/InstarVision2_Layout_8x8.avif 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/49a1b5f90ef182ffbef46d05ec7c6f29/a0b58/InstarVision2_Layout_8x8.webp 230w", "/de/static/49a1b5f90ef182ffbef46d05ec7c6f29/bc10c/InstarVision2_Layout_8x8.webp 460w", "/de/static/49a1b5f90ef182ffbef46d05ec7c6f29/966d8/InstarVision2_Layout_8x8.webp 920w", "/de/static/49a1b5f90ef182ffbef46d05ec7c6f29/a9a89/InstarVision2_Layout_8x8.webp 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/49a1b5f90ef182ffbef46d05ec7c6f29/81c8e/InstarVision2_Layout_8x8.png 230w", "/de/static/49a1b5f90ef182ffbef46d05ec7c6f29/08a84/InstarVision2_Layout_8x8.png 460w", "/de/static/49a1b5f90ef182ffbef46d05ec7c6f29/c0255/InstarVision2_Layout_8x8.png 920w", "/de/static/49a1b5f90ef182ffbef46d05ec7c6f29/2bef9/InstarVision2_Layout_8x8.png 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/49a1b5f90ef182ffbef46d05ec7c6f29/c0255/InstarVision2_Layout_8x8.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      